module.exports = __webpack_public_path__ + "img/20200922_changzhou_shengjiangtai.dd15dc88.jpg";